<h1 class="text-center" [innerHTML]="'wpcheck.eingabe.start.headline' | translate: welcomePlaceholder"></h1>
<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-offset-2 medium-3">
    <app-advisor-image path="/wpc/wpc-intro.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
    <p [innerHTML]="'wpcheck.eingabe.start.teaser' | translate"></p>
  </div>
  <div class="cell small-12 medium-offset-1 medium-10">
    <div class="button-wrapper background">
      <div [innerHTML]="'wpcheck.eingabe.start.callout1' | translate"></div>
      <button type="button" [routerLink]="nextLink" class="button primary inline-arrow-right">{{'wpcheck.eingabe.start.next' | translate}}</button>
    </div>
  </div>
</div>
